/*
 *  price-alignment.ts
 *
 *  describe the max length of the integral- and the max length of the fractional part for a set of prices
 */
import { formatDecimalAsString } from '@/utils/helpers/auction-numbers';
import Decimal from 'decimal.js';

export function getPriceFractionalLength(tickSize: number): number {
  const d = new Decimal(tickSize);
  return d.decimalPlaces();
}

export function getDecimalIntegralLength(d: Decimal): number {
  return formatDecimalAsString(d, 0).length;
}
